import { gql } from "graphql-request";

export const GET_EXCLUSION_LISTS = gql`
  query GetExclusionLists($pageNo: Int, $pageSize: Int, $active: Boolean) {
    exclusionLists(pageNo: $pageNo, pageSize: $pageSize, active: $active) {
      data {
        _id
        name
        effectRate
        active
        startDate
        endDate
        codesCount
        targetColumnCount
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_EXCLUSION_LIST = gql`
  query GetExclusionList($id: ID!) {
    exclusionList(id: $id) {
      _id
      name
      targetColumnIds
      codes
      effectRate
      active
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_EXCLUSION_LIST = gql`
  mutation CreateExclusionList($input: ExclusionListInput!) {
    createExclusionList(input: $input) {
      _id
      name
      targetColumnIds
      codes
      effectRate
      active
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_EXCLUSION_LIST = gql`
  mutation UpdateExclusionList($id: ID!, $input: ExclusionListUpdateInput!) {
    updateExclusionList(id: $id, input: $input) {
      _id
      name
      targetColumnIds
      codes
      effectRate
      active
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_EXCLUSION_LIST = gql`
  mutation DeleteExclusionList($id: ID!) {
    deleteExclusionList(id: $id)
  }
`;


